const getButtonAppointment = document.getElementById('js-button-appointment');
const getOfficesNumberContainer = document.getElementById('js-offices-number');
const getCloseOfficesContainer = document.getElementById('js-close-offices-number');
const getSvgArrow = document.getElementById('button-appointment-arrow');

if(getButtonAppointment){
  getButtonAppointment.addEventListener("click",function() {
    getOfficesNumberContainer.classList.toggle("showOfficesNumberContainer");
    getSvgArrow.classList.toggle('rotateSvg');
  });
}

if(getCloseOfficesContainer){
  getCloseOfficesContainer.addEventListener('click',function() {
    getOfficesNumberContainer.classList.remove("showOfficesNumberContainer");
    getSvgArrow.classList.remove('rotateSvg');
  });
}